/* Product page videos: play silently while on screen (like a reel), pause when you
   scroll away, tap the speaker to hear sound. Stays out of the way for YouTube/Vimeo,
   data-saver mode and "reduce motion". */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  if (reduce || saveData || !('IntersectionObserver' in window)) return;

  var ICON_OFF = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H2v6h4l5 4V5z"/><path d="m22 9-6 6M16 9l6 6"/></svg>';
  var ICON_ON = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H2v6h4l5 4V5z"/><path d="M15.5 8.5a5 5 0 0 1 0 7M19 5a10 10 0 0 1 0 14"/></svg>';

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var dm = en.target;
      var v = dm.querySelector('video');
      if (en.isIntersecting) {
        if (!v) {
          if (typeof dm.loadContent !== 'function') return;
          dm.loadContent(false); // same loader the poster tap uses
          v = dm.querySelector('video');
          if (!v) return;
          v.muted = true; v.loop = true; v.playsInline = true;
          v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
          v.addEventListener('pause', function () {
            if (v.__nvPausing) v.__nvPausing = false; else v.__nvUserPaused = true;
          });
          v.addEventListener('play', function () { v.__nvUserPaused = false; });
          addSound(dm, v);
        }
        if (!v.__nvUserPaused) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
      } else if (v && !v.paused) {
        v.__nvPausing = true;
        v.pause();
      }
    });
  }, { threshold: 0.6 });

  function addSound(dm, v) {
    if (dm.querySelector('.nv-vsound')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'nv-vsound';
    b.setAttribute('aria-label', 'Sound on or off');
    b.innerHTML = ICON_OFF;
    b.addEventListener('click', function (e) {
      e.stopPropagation();
      v.muted = !v.muted;
      b.innerHTML = v.muted ? ICON_OFF : ICON_ON;
      if (!v.muted && v.paused) v.play();
    });
    dm.appendChild(b);
  }

  function scan(scope) {
    (scope || document).querySelectorAll('media-gallery deferred-media').forEach(function (dm) {
      if (dm.__nvVid || dm.closest('product-modal')) return;
      var tpl = dm.querySelector('template');
      if (!tpl || !tpl.content.querySelector('video')) return; // YouTube / Vimeo / 3D: leave alone
      dm.__nvVid = true;
      io.observe(dm);
    });
  }

  function init() { scan(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
